<template>
  <div class="contenBox">
    <div class="contenBox_top">
      <div>
        <div class="dataList1">
          <div class="abs_puxi">
            {{ currentData.TREE_NAME }}
          </div>
          <p style="margin-top: 18px;">
            <span class="abs_puxi_time">{{ listData.CREATE_DATE }}</span>
            <span style="color: #999999;font-size: 13px;margin-left: 16px;">彭祖世家网</span>
            <span style="color: #999999;font-size: 13px;margin-left: 16px;">{{ listData.USER_NAME }}</span>
            <span v-if="listData.SHOW_ABSTRACT" class="ab_span">{{ listData.SHOW_ABSTRACT }}</span>
            <span style="display: block;padding: 0 35px" v-html="listData.SHOW_TEXT" />
          </p>
        </div>
      </div>
    </div>
    <ul class="showulnav">
      <li :class="currentIndex===1?'active':'noactive'" @click="handelNav(1)">
        全部人物
      </li>
      <span>/</span>
      <li :class="currentIndex===3?'active':'noactive'" @click="handelNav(3)">
        重要人物
      </li>
    </ul>
    <div style="overflow: hidden;width: 100%;">
      <div v-show="currentIndex===1" class="dataList1 dataList1_1">
        <div v-if="!islogin" class="loginShadow" :style="'background-image:url('+listsd+')'">
          <div class="contentlogin">
            <p>亲，告诉你个秘密:-D</p>
            <p>登录后，可以查看更多搜索结果哦！</p>
            <span class="loginbt" @click="showlogin">立即登录</span>
            <a class="registerbt" href="/register">免费注册</a>
          </div>
        </div>
        <div class="nodeall">
          <span style="margin-left: 20px;">共有</span><span>{{ renwuData.count }}</span><span>个人物记录</span>
        </div>
        <div v-for="(item,index) in renwuData.listMapData" :key="index">
          <div class="lislist">
            <div class="hasImg">
              <p>
                <span class="nameshow" @click="godetail(item.NODE_ID)">{{ item.NODE_NAME }}</span>
                <span v-if="item.NODE_LIFE_FLAG==1" style="display: inline-block;width: 25px;height: 25px;background-color: black;color: #ffffff;text-align: center;line-height: 25px;margin-left: 25px">殁</span>
                <span style="float: right;font-weight: 400;color: #333333;margin-right: 35px">{{ item.NODE_NUMBER|changedai }}</span>
              </p>
            </div>
          </div>
        </div>
        <div v-if="renwuData.count>0" style="text-align: center;margin-top: 20px;" class="pagina_box">
          <el-pagination
            :small="isSmall"
            :pager-count="pagecount"
            :current-page="params1.index"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="10"
            :layout="layoutType"
            :total="renwuData.count"
            @size-change="handleSizeChange1"
            @current-change="handleCurrentChange1"
          />
        </div>
        <div v-else style="font-size: 20px;font-weight: 600;color: #A19D9E">
          暂无数据
        </div>
      </div>
      <div v-show="currentIndex===2" class="dataList1 dataList1_1">
        <div class="dataList1_div">
          <div v-if="fenfangData.count>0">
            <span>房系名称</span><span>世系数</span><span>节点</span>
            <div v-for="(item,index) in fenfangData.listMapData" :key="index">
              <span style="display: inline-block;width: 260px;color: #333333;font-size: 15px;margin: 10px 0;">{{ item.NODE_BRANCH_TITLE }}</span>
              <span style="display: inline-block;width: 260px;color: #333333;font-size: 15px;margin: 10px 0;">{{ item.NODE_NUMBER }}</span>
              <span style="display: inline-block;width: 260px;color: #333333;font-size: 15px;margin: 10px 0;">{{ item.BRANCH_NODE_SIZE }}</span>
            </div>
            <div style="text-align: center;margin-top: 20px;" class="pagina_box">
              <el-pagination
                :small="isSmall"
                :pager-count="pagecount"
                :current-page="params2.index"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="10"
                :layout="layoutType"
                :total="fenfangData.count"
                @size-change="handleSizeChange2"
                @current-change="handleCurrentChange2"
              />
            </div>
          </div>
          <div v-else style="font-size: 20px;font-weight: 600;color: #A19D9E">
            暂无数据
          </div>
        </div>
      </div>
      <div v-show="currentIndex===3" class="dataList1 dataList1_1">
        <div v-if="!islogin" class="loginShadow" :style="'background-image:url('+listsd+')'">
          <div class="contentlogin">
            <p>亲，告诉你个秘密:-D</p>
            <p>登录后，可以查看更多搜索结果哦！</p>
            <span class="loginbt" @click="showlogin">立即登录</span>
            <a class="registerbt" href="/register">免费注册</a>
          </div>
        </div>
        <div class="nodeall">
          <span style="margin-left: 20px;">共有</span><span>{{ nodeData.count }}</span><span>个人物</span>
        </div>
        <div v-for="(item,index) in nodeData.listMapData" :key="index">
          <div class="lislist">
            <div class="hasImg">
              <p>
                <span class="nameshow" @click="godetail(item.NODE_ID)">{{ item.NODE_NAME }}</span>
                <span v-if="item.NODE_LIFE_FLAG==1" style="display: inline-block;width: 25px;height: 25px;background-color: black;color: #ffffff;text-align: center;line-height: 25px;margin-left: 25px">殁</span>
                <span style="float: right;font-weight: 400;color: #333333;margin-right: 35px">{{ item.NODE_NUMBER|changedai }}</span>
              </p>
            </div>
          </div>
        </div>
        <div v-if="nodeData.count>0" style="text-align: center;margin-top: 20px;padding-bottom: 20px" class="pagina_box">
          <el-pagination
            :small="isSmall"
            :pager-count="pagecount"
            :current-page="params3.index"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="10"
            :layout="layoutType"
            :total="nodeData.count"
            @size-change="handleSizeChange3"
            @current-change="handleCurrentChange3"
          />
        </div>
        <div v-else style="font-size: 20px;font-weight: 600;color: #A19D9E">
          暂无数据
        </div>
      </div>
    </div>
    <el-dialog
       custom-class="loginBoxs"
      :visible.sync="seelogin"
      width="850px"
      :before-close="handleClose"
    >
      <loginShow />
    </el-dialog>
  </div>
</template>
<script>
import request from '@/utils/request'
import loginShow from '@/components/logincomponent/index.vue'
export default {
  components: { loginShow },
  filters: {
    changedai: val => {
      var numToZHCNStr = function(num, yearBol) {
        var chnNumChar = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
        var numStr = parseInt(num).toString().split('')
        if (isNaN(parseInt(num))) {
          numStr = ['0']
        }
        if (yearBol) {
          var Str = ''
          for (var i = 0; i < numStr.length; i++) {
            Str += chnNumChar[parseInt(numStr[i])]
          }
          return Str
        } else {
          if (numStr.toString() == '1,0') {
            return '十'
          }
          if (numStr.length == 1) {
            return chnNumChar[parseInt(numStr[0])]
          } else if (numStr.length == 2) {
            if (parseInt(numStr[0]) == 1) {
              return '十' + chnNumChar[parseInt(numStr[1])]
            } else {
              return chnNumChar[parseInt(numStr[0])] + chnNumChar[parseInt(numStr[1])]
            }
          } else {
            var Str2 = ''
            for (var i = 0; i < numStr.length; i++) {
              Str2 += chnNumChar[parseInt(numStr[i])]
            }
            return Str2
          }
        }
      }
      return '[第' + numToZHCNStr(val) + '世]'
    }
  },
  props: ['listData', 'currentData'],
  inject: ['reload'],
  data() {
    return {
      listsd: require('@/static/listshadow2.png'),
      seelogin: false,
      islogin: false,
      isSmall: false,
      pagecount: 5,
      layoutType: 'total, sizes, prev, pager, next, jumper',
      currentIndex: 1,
      peng1: require('@/static/pushuimg1.png'),
      renwuData: [],
      fenfangData: [],
      nodeData: [],
      params1: {
        index: 1,
        size: 10,
        // bookId: this.$route.query.sourceId
        treeId: this.$route.query.sourceId
      },
      params2: {
        index: 1,
        size: 10,
        treeId: this.$route.query.sourceId
      },
      params3: {
        index: 1,
        size: 10,
        treeId: this.$route.query.sourceId,
        seaType: 1
      }
    }
  },
  mounted() {
    if (this.getLoca('userid')) {
      this.islogin = true
    }
    this.isphone()
    this.params1.index = 1
    this.fetchData('/portalTree/getTreeNodeList', this.params1, 1)
  },
  methods: {
    handelNav(index) {
      this.currentIndex = index
      if (index === 1) {
        this.params1.index = 1
        this.fetchData('/portalTree/getTreeNodeList', this.params1, 1)
      }
      if (index === 2) {
        this.params2.index = 1
        this.fetchData('/portalTree/getTreeNodeBranchSize', this.params2, 2)
      }
      if (index === 3) {
        this.params3.index = 1
        this.fetchData('/portalTree/getTreeNodeList', this.params3, 3)
      }
    },
    handleSizeChange1(size) {
      this.params1.size = size
      this.fetchData('/portalTree/getTreeNodeList', this.params1, 1)
    },
    handleCurrentChange1(page) {
      this.params1.index = page
      this.fetchData('/portalTree/getTreeNodeList', this.params1, 1)
    },
    handleSizeChange2(size) {
      this.params2.size = size
      this.fetchData('/portalTree/getTreeNodeBranchSize', this.params2, 1)
    },
    handleCurrentChange2(page) {
      this.params2.index = page
      this.fetchData('/portalTree/getTreeNodeBranchSize', this.params2, 1)
    },
    handleSizeChange3(size) {
      this.params3.size = size
      this.fetchData('/portalTree/getTreeFirstList', this.params3, 3)
    },
    handleCurrentChange3(page) {
      this.params3.index = page
      this.fetchData('/portalTree/getTreeFirstList', this.params3, 3)
    },
    fetchData(url, params, index) {
      request({
        url: url,
        method: 'post',
        params: params
      }).then(res => {
        if (index === 1) {
          this.renwuData = res.data
        }
        if (index === 2) {
          this.fenfangData = res.data
        }
        if (index === 3) {
          this.nodeData = res.data
        }
      })
    },
    godetail(sourceId) {

    },
    isphone() {
      var is_mobi = navigator.userAgent.toLowerCase().match(/(ipod|ipad|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i) != null
      if (is_mobi) {
        this.layoutType = 'total, prev,pager, next'
        this.isSmall = true
      } else {
        this.layoutType = 'total, sizes, prev, pager, next, jumper'
      }
    },
    showlogin() {
      this.seelogin = true
    },
    handleClose() {
      this.seelogin = false
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .dataList1_1{
    overflow: hidden;
    position: relative;
    min-height: 881px;
  }
  .loginShadow{
    position: absolute;
    height: 606px;
    width: 880px;
    top: 273px;;
    left: 0;
    z-index: 2;
    .contentlogin{
      overflow: hidden;
      margin-top: 220px;
      text-align: center;
      p{
        text-align: center;
        font-size: 18px;
        margin-bottom: 16px;
        color: #333;
      }
      .loginbt{
        display: inline-block;
        width: 120px;
        text-align: center;
        padding: 8px 8px;
        background-color: #FD485E;
        color: #ffffff;
        margin-top: 15px;
        cursor: pointer;
        border-radius: 3px;
        &:hover{
          background-color: #dd1e32;
        }
      }
      .registerbt{
        display: inline-block;
        width: 120px;
        text-align: center;
        padding: 8px 8px;
        background-color: #128BED;
        margin-left: 25px;
        color: #ffffff;
        margin-top: 15px;
        cursor: pointer;
        border-radius: 3px;
        &:hover{
          background-color: #146ca4;
        }
      }
    }
  }

  .nodeall{
    padding-top: 20px;
  }
  .abs_puxi_time{
    color: #999999;
    font-size: 13px;
    margin-left: 35px;
  }
  .abs_puxi{
    font-size: 18px;
    color: #333333;
    margin-left: 35px;
  }
  .pagina_box{
    padding-bottom: 20px;
  }
  .nameshow{
    font-size: 18px;
    font-weight: 600;
    cursor: pointer;
    &:hover{
      color: #ed4040;
    }
  }
  .lislist{
    padding: 25px 0;
    border-bottom: 1px solid #EDEDED;
    background-color: #fff;
    padding-left: 35px;
  }
  .showulnav{
    height: 60px;
    line-height: 60px;
    background-color: #fff;
    text-align: center;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .title{
    height: 20px;
    line-height: 20px;
    border-left: 2px solid #ed4040;
    padding-left: 10px;
    font-size: 16px;
    margin-left: 20px;
  }
  .tuijian{
    overflow: hidden;
    background-color: #fff;
  }
  .contenBox_top{
    background-color: #fff;
    overflow: hidden;
    padding-top: 20px;
    padding-bottom: 20px;
    margin-bottom: 20px;
  }
  .ab_span{
    display: inline-block;
    background-color:#F8F8F8;
    color: #666666;
    width:810px;
    padding: 15px 0px;
    margin: 20px 0;
    margin-left: 35px;
  }
  .dataList1_div{
    margin-top: 20px;
    overflow: hidden;
    span{
      display: inline-block;
      width: 260px;
      color: #999999;
      font-size: 12px;
    }
  }
  .contenBox{
    width: 880px;
    overflow: hidden;
    .active{
      font-size: 16px;
      display: inline-block;
      padding: 0 8px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      cursor: pointer;
      color: #ed4040;
      font-weight: 600;
    }
    .noactive{
      font-size: 16px;
      display: inline-block;
      padding: 0 8px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      cursor: pointer;
      color: #333333;
      font-weight: 600;
    }
    .dataList1{
      background-color: #fff;
      .hasImg{
        overflow: hidden;
        vertical-align: top;
        .content_cext{
          line-height: 20px;
          margin-top: 20px;
          display: inline-block;
          overflow: hidden;
          font-size: 12px;
          color: #666666;
          text-overflow:ellipsis;
          display:-webkit-box;
          -webkit-box-orient:vertical;
          -webkit-line-clamp:3;
        }
      }
    }
  }
</style>
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px) {
    .contenBox{
      width: 100%!important;
      ul{
        width: 100%!important;
        white-space: nowrap;
        overflow-x: auto;
        li{
          width: 60px;
        }
        .noactive{
          width: 60px;
        }
        .active{
          width: 60px;
        }
      }
      .ab_span{
        width: 100%!important;
      }
      .noImg{
        width: 100%!important;
      }
      .hasImg{
        width: 100%!important;
        height: 30px!important;
        padding-left: 0!important;
      }
      .pagina_box{
        white-space: nowrap;
        overflow-x: auto;
        background-color: #fff;
        margin-top: 0!important;
        padding-top: 20px;
      }
    }
    .abs_puxi{
      margin-left: 0;
    }
    .contenBox .dataList1{
      background-color: #F9F9F9;
    }
    .contenBox_top{
      background-color: #F9F9F9;
    }
    .abs_puxi_time{
      margin-left: 0;
    }
    .nodeall{
      padding-top: 0;
      padding: 10px 0;
    }
  }
</style>

